/** @format */

import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { getSellerProfile, sellerIsBlock } from "../../store/seller/seller.action";
import { useNavigate } from "react-router-dom";
import Shop from "./Profile/Shop";
import SellerProduct from "./Profile/SellerProduct";
import Transition from "./Profile/Transition";
import SellerOrder from "./Profile/SellerOrder";

const tabs = [
	{ key: "Shop", label: "Shop", icon: "fa-store" },
	{ key: "Product", label: "Products", icon: "fa-box" },
	{ key: "Order", label: "Orders", icon: "fa-receipt" },
	{ key: "Transition", label: "Transactions", icon: "fa-arrow-right-arrow-left" },
];

const SellerProfile = () => {
	const [type, setType] = useState(() => {
		const saved = sessionStorage.getItem("Shop");
		return saved !== null ? saved : "Shop";
	});
	const navigate = useNavigate();

	useEffect(() => {
		sessionStorage.setItem("Shop", type);
	}, [type]);

	return (
		<div style={{ padding: "0 8px" }}>
			{/* Header */}
			<div className='d-flex justify-content-between align-items-center' style={{ padding: "20px 8px 0" }}>
				<div>
					<h4 style={{ fontWeight: 700, color: "#0f172a", margin: 0 }}>Seller Profile</h4>
					<p style={{ color: "#64748b", fontSize: "13px", margin: "4px 0 0" }}>View seller details, products, orders & transactions</p>
				</div>
				<button
					onClick={() => navigate(-1)}
					className='btn'
					style={{
						border: "1px solid #e2e8f0",
						borderRadius: "8px",
						padding: "8px 20px",
						fontWeight: 500,
						color: "#334155",
						fontSize: "14px",
					}}>
					← Back
				</button>
			</div>

			{/* Tab Navigation */}
			<div
				style={{
					display: "flex",
					gap: "4px",
					padding: "20px 8px 0",
					borderBottom: "1px solid #e2e8f0",
				}}>
				{tabs.map((tab) => {
					const isActive = type === tab.key;
					return (
						<button
							key={tab.key}
							onClick={() => setType(tab.key)}
							style={{
								display: "flex",
								alignItems: "center",
								gap: "8px",
								padding: "10px 20px",
								fontSize: "14px",
								fontWeight: isActive ? 600 : 500,
								color: isActive ? "#e54a13" : "#64748b",
								background: "none",
								border: "none",
								borderBottom: isActive ? "2px solid #e54a13" : "2px solid transparent",
								cursor: "pointer",
								transition: "all 0.2s ease",
								marginBottom: "-1px",
							}}>
							<i className={`fa-solid ${tab.icon}`} style={{ fontSize: "13px" }} />
							{tab.label}
						</button>
					);
				})}
			</div>

			{/* Tab Content */}
			<div style={{ padding: "0 0px" }}>
				{type === "Shop" && <Shop />}
				{type === "Product" && <SellerProduct />}
				{type === "Transition" && <Transition />}
				{type === "Order" && <SellerOrder />}
			</div>
		</div>
	);
};

export default connect(null, {
	getSellerProfile,
	sellerIsBlock,
})(SellerProfile);
